(() => {
  const D = document, H = D.documentElement;
  H.classList.add('sgl-js');
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const smooth = () => (reduce() ? 'auto' : 'smooth');
  const root_ = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Shipping dates: order today, shipped +2, delivered +7 to +10 calendar days, local time. */
  function fmtRange(now, start, end, locale) {
    const day = n => new Date(now.getFullYear(), now.getMonth(), now.getDate() + n, 12);
    const a = day(start), b = day(Math.max(start, end));
    const opts = { month: 'short', day: 'numeric' };
    if (b.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
    const f = new Intl.DateTimeFormat(locale, opts);
    let text;
    if (start === end) text = f.format(a);
    else if (f.formatRange) text = f.formatRange(a, b);
    else text = f.format(a) + ' to ' + f.format(b);
    return { a, b, text };
  }
  let shipTimer;
  function updateShipDates() {
    clearTimeout(shipTimer);
    const now = new Date(), loc = H.lang || 'en-US';
    D.querySelectorAll('[data-sgl-ship-date]').forEach(el => {
      const s = Number(el.dataset.start), e = Number(el.dataset.end);
      if (!Number.isFinite(s) || !Number.isFinite(e)) return;
      const r = fmtRange(now, s, e, loc);
      el.textContent = r.text;
      const full = new Intl.DateTimeFormat(loc, { dateStyle: 'long' });
      el.setAttribute('aria-label', s === e ? full.format(r.a) : full.format(r.a) + ' to ' + full.format(r.b));
    });
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    shipTimer = setTimeout(updateShipDates, midnight - now + 200);
  }
  addEventListener('pageshow', updateShipDates);
  D.addEventListener('visibilitychange', () => { if (!D.hidden) updateShipDates(); });

  /* Free gift: one Fit Kit per order with a Snugline pack, made free by the gift code. */
  const Gift = (() => {
    let cfg = null, pending = null;
    async function req(path, body, tries = 2) {
      const r = await fetch(root_() + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
      let d;
      try { d = JSON.parse(await r.text()); } catch (e) {
        if (tries > 1) { await new Promise(z => setTimeout(z, 500)); return req(path, body, tries - 1); }
        throw Error('Your cart is busy. Please try again in a moment.');
      }
      if (!r.ok || d.status) throw Error(d.description || d.message || 'Your cart could not be updated. Please try again.');
      return d;
    }
    async function reconcile() {
      if (!cfg || !cfg.gift) return null;
      let cart = await req('cart.js');
      const isPack = i => cfg.packs.includes(Number(i.variant_id));
      const gifts = cart.items.filter(i => Number(i.variant_id) === cfg.gift);
      const want = cart.items.some(isPack) ? 1 : 0;
      const have = gifts.reduce((n, i) => n + i.quantity, 0);
      const codes = (cart.discount_codes || []).map(d => d.code);
      const own = cfg.code.toUpperCase();
      const others = codes.filter(c => c.toUpperCase() !== own);
      const applied = codes.some(c => c.toUpperCase() === own);
      const free = gifts.every(i => i.final_line_price === 0);
      if (have === want && (want === 0 ? !applied : applied && free)) return cart;
      const updates = {};
      if (gifts.length) gifts.forEach((g, k) => { updates[g.key] = k === 0 ? want : 0; });
      else if (want) updates[cfg.gift] = want;
      const drawer = D.querySelector('cart-drawer');
      const sections = (drawer && drawer.getSectionsToRender && drawer.getSectionsToRender().map(s => s.id)) || [];
      cart = await req('cart/update.js', { updates, discount: [...others, ...(want ? [cfg.code] : [])].join(','), sections, sections_url: location.pathname });
      const charged = cart.items.filter(i => Number(i.variant_id) === cfg.gift && i.final_line_price > 0);
      if (want && charged.length) {
        const rm = {};
        charged.forEach(i => { rm[i.key] = 0; });
        cart = await req('cart/update.js', { updates: rm, sections, sections_url: location.pathname });
        if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
        throw Error('Your Snugline pack is in the cart, but the free Fit Kit could not be applied. Please contact us before checkout.');
      }
      if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
      return cart;
    }
    return { set(c) { cfg = c; }, sync() { if (!pending) pending = reconcile().finally(() => { pending = null; }); return pending; } };
  })();
  window.SglGift = Gift;

  function initReveal() {
    const secs = D.querySelectorAll('.sg-s[data-sgl-reveal]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      secs.forEach(s => io.observe(s));
    } else secs.forEach(s => s.classList.add('is-in'));
    const catchUp = () => secs.forEach(s => { if (s.getBoundingClientRect().top < innerHeight) s.classList.add('is-in'); });
    addEventListener('scroll', () => requestAnimationFrame(catchUp), { passive: true });
    catchUp();
  }

  let api = null;

  function init() {
    updateShipDates();
    initReveal();
    const root = D.querySelector('#sgl');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('.sg-proof .ceyla-rproof__text').forEach(p => p.childNodes.forEach(n => { if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' '; }));

    const money = c => new Intl.NumberFormat(H.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(c / 100);
    const short = s => s.replace(/\.00(?=\D*$)/, '');
    const packs = [...root.querySelectorAll('[name="sgl-pack"]')];
    const widths = [...root.querySelectorAll('[name="sgl-width"]')];
    const addons = [...root.querySelectorAll('[data-sgl-addon]')];
    let pack = Number(root.dataset.pack) || 2;
    let width = root.dataset.width || 'std';

    const info = (p, w) => {
      const r = packs.find(x => x.value === String(p)) || packs[0];
      const k = w === 'wide' ? 'wide' : 'std';
      return {
        r,
        variant: Number(r.dataset[k + 'Variant']),
        price: Number(r.dataset[k + 'Price']),
        compare: Number(r.dataset[k + 'Compare'] || 0),
        media: r.dataset[k + 'Media'],
        available: r.dataset[k + 'Avail'] === 'true',
        rolls: Number(r.dataset.rolls || 1)
      };
    };
    const allVariants = [];
    packs.forEach(r => { ['std', 'wide'].forEach(k => { const v = Number(r.dataset[k + 'Variant']); if (v) allVariants.push(v); }); });
    Gift.set({ packs: allVariants, gift: Number(root.dataset.giftVariant) || 0, code: root.dataset.giftCode || 'SNUGFITKIT' });

    /* Gallery */
    const g = root.querySelector('[data-sgl-gallery]');
    const slides = [...g.querySelectorAll('.sg-slide')];
    const thumbs = [...root.querySelectorAll('.sg-thumb')];
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : g.clientWidth) || g.clientWidth;
    const idx = () => Math.max(0, Math.min(slides.length - 1, Math.round(g.scrollLeft / step())));
    const to = (i, instant) => g.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * step(), behavior: instant ? 'auto' : smooth() });
    root.querySelectorAll('[data-sgl-slide]').forEach(b => b.addEventListener('click', () => to(Number(b.dataset.sglSlide))));
    const nx = root.querySelector('[data-sgl-next]'), pv = root.querySelector('[data-sgl-prev]');
    if (nx) nx.addEventListener('click', () => to(idx() + 1));
    if (pv) pv.addEventListener('click', () => to(idx() - 1));
    let raf;
    g.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = idx();
        thumbs.forEach((t, j) => { t.classList.toggle('is-on', i === j); t.setAttribute('aria-pressed', String(i === j)); });
        const at = thumbs[i], row = at && at.parentElement;
        if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: at.offsetLeft - row.clientWidth / 2 + at.clientWidth / 2, behavior: smooth() });
      });
    }, { passive: true });
    g.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); to(idx() + (e.key === 'ArrowRight' ? 1 : -1)); } });

    const termsId = root.querySelector('[data-sgl-terms-id]');
    const addonTotal = () => addons.reduce((n, a) => n + (a.checked && !a.closest('[data-sgl-addon-row]').hidden ? Number(a.dataset.price) : 0), 0);
    const setText = (sel, v) => D.querySelectorAll(sel).forEach(el => { el.textContent = v; });

    function paint(fromUser) {
      const t = info(pack, width);
      packs.forEach(r => { r.checked = r.value === String(pack); r.closest('.sg-pack').classList.toggle('is-on', r.checked); });
      widths.forEach(r => { r.checked = r.value === width; r.closest('.sg-wopt').classList.toggle('is-on', r.checked); });
      /* Card prices follow the chosen width */
      packs.forEach(r => {
        const c = info(Number(r.value), width), card = r.closest('.sg-pack');
        const pe = card.querySelector('[data-sgl-card-price]'), ce = card.querySelector('[data-sgl-card-compare]'), ue = card.querySelector('[data-sgl-card-unit]');
        if (pe) pe.textContent = money(c.price);
        if (ce) { ce.hidden = !(c.compare > c.price); ce.textContent = money(c.compare); }
        if (ue) ue.textContent = c.rolls > 1 ? short(money(Math.round(c.price / c.rolls))) + ' per roll' : '';
      });
      /* Wide upgrade difference for this pack */
      const std = info(pack, 'std'), wide = info(pack, 'wide');
      const diff = wide.price - std.price;
      setText('[data-sgl-wide-diff]', diff > 0 ? '+' + short(money(diff)) : 'Same price');
      /* Add-on rows by pack */
      root.querySelectorAll('[data-sgl-addon-row]').forEach(row => {
        const show = (row.dataset.packs || '').split(',').map(x => x.trim()).includes(String(pack));
        row.hidden = !show;
        if (!show) { const cb = row.querySelector('input'); if (cb) cb.checked = false; }
      });
      const ah = root.querySelector('.sg-addons');
      if (ah) ah.hidden = !root.querySelector('[data-sgl-addon-row]:not([hidden])');
      setText('[data-sgl-price]', money(t.price));
      const c = root.querySelector('[data-sgl-compare]'), s = root.querySelector('[data-sgl-save]');
      if (t.compare > t.price) { c.hidden = false; s.hidden = false; c.textContent = money(t.compare); s.textContent = 'Save ' + short(money(t.compare - t.price)); }
      else { c.hidden = true; s.hidden = true; }
      const total = t.price + addonTotal();
      setText('[data-sgl-atc-total]', money(total));
      setText('[data-sgl-sticky-price]', money(total));
      if (termsId && termsId.value !== String(t.variant)) { termsId.value = t.variant; termsId.dispatchEvent(new Event('change', { bubbles: true })); }
      const main = root.querySelector('.sg-atc[data-sgl-add]');
      if (main) main.disabled = !t.available;
      D.querySelectorAll('[data-sgl-kit-pick]').forEach(b => {
        const want = b.dataset.sglKitPick;
        let on = false;
        if (want === 'guard') on = pack === 3 || !!root.querySelector('[data-sgl-addon="guard"]:checked');
        else on = !!root.querySelector('[data-sgl-addon="' + want + '"]:checked');
        b.setAttribute('aria-pressed', String(on));
        const sp = b.querySelector('span');
        if (sp) sp.textContent = on ? sp.dataset.on : sp.dataset.off;
      });
      if (fromUser) {
        if (t.variant) { const u = new URL(location.href); u.searchParams.set('variant', t.variant); history.replaceState(history.state, '', u); }
        if (t.media) {
          const si = slides.findIndex(sl => sl.dataset.mediaId === t.media);
          if (si >= 0 && root.querySelector('.sg-buy').getBoundingClientRect().top < innerHeight) to(si);
        }
        const card = t.r.closest('.sg-pack');
        if (card && !reduce()) { card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop'); }
      }
    }
    packs.forEach(r => r.addEventListener('change', () => { pack = Number(r.value); paint(true); }));
    widths.forEach(r => r.addEventListener('change', () => { width = r.value; paint(true); }));
    addons.forEach(a => a.addEventListener('change', () => paint(false)));
    paint(false);
    addEventListener('pageshow', () => paint(false));

    api = {
      selectPack(p) { pack = p; paint(true); root.querySelector('#sgl-buy').scrollIntoView({ behavior: smooth(), block: 'start' }); },
      toggleAddon(key) {
        if (key === 'guard' && pack === 3) { root.querySelector('#sgl-buy').scrollIntoView({ behavior: smooth(), block: 'start' }); return; }
        const cb = root.querySelector('[data-sgl-addon="' + key + '"]');
        if (!cb) return;
        if (cb.closest('[data-sgl-addon-row]').hidden) return;
        cb.checked = !cb.checked; paint(false);
      }
    };

    /* Cart */
    async function drawerReady() {
      await customElements.whenDefined('cart-drawer');
      const d = D.querySelector('cart-drawer');
      if (!d || typeof d.renderContents !== 'function') throw Error('The cart is still loading. Please try again.');
      return d;
    }
    const setCount = n => root.querySelectorAll('[data-sgl-count]').forEach(e => { e.textContent = n; });
    const vipFirst = () => {
      const sheet = D.querySelector('.vf-root'), bag = D.querySelector('cart-drawer');
      if (!sheet || !bag || sheet.classList.contains('open')) return;
      const hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
      Object.keys(hide).forEach(p => bag.style.setProperty(p, hide[p], 'important'));
      let ticks = 0;
      const tm = setInterval(() => { if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach(p => bag.style.removeProperty(p)); } }, 100);
    };
    let busy = false;
    async function add(e) {
      if (busy) return;
      const btn = e.currentTarget, t = info(pack, width);
      if (!t.available || !t.variant) return;
      busy = true;
      const buttons = [...D.querySelectorAll('[data-sgl-add]')];
      buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      const err = root.querySelector('[data-sgl-error]');
      err.textContent = '';
      try {
        const drawer = await drawerReady();
        if (drawer.setActiveElement) drawer.setActiveElement(btn);
        const sections = drawer.getSectionsToRender().map(s => s.id);
        const items = [{ id: t.variant, quantity: 1 }];
        addons.forEach(a => { if (a.checked && !a.closest('[data-sgl-addon-row]').hidden) items.push({ id: Number(a.dataset.variant), quantity: 1 }); });
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections, sections_url: location.pathname }) });
        let data;
        try { data = JSON.parse(await res.text()); } catch (x) { throw Error('Your Snugline pack could not be added. Please try again.'); }
        if (!res.ok || data.status) throw Error(data.description || data.message || 'Your Snugline pack could not be added. Please try again.');
        vipFirst();
        drawer.renderContents(data);
        let cart;
        try { cart = await Gift.sync(); } catch (ge) { err.textContent = ge.message; }
        if (!cart) cart = await fetch(root_() + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        setCount(cart.item_count);
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        drawer.open(btn);
      } catch (x) {
        err.textContent = x.message || 'Please check your cart before trying again.';
        err.scrollIntoView({ block: 'center', behavior: smooth() });
      } finally {
        busy = false;
        buttons.forEach(b => { b.removeAttribute('aria-busy'); b.disabled = false; });
        paint(false);
      }
    }
    D.querySelectorAll('[data-sgl-add]').forEach(b => b.addEventListener('click', add));
    root.querySelectorAll('[data-sgl-cart]').forEach(b => b.addEventListener('click', async () => {
      try {
        const d = await drawerReady();
        await Gift.sync();
        const ids = d.getSectionsToRender().map(s => s.id);
        const [sections, c] = await Promise.all([fetch(root_() + '?sections=' + ids.join(',')).then(r => r.json()), fetch(root_() + 'cart.js').then(r => r.json())]);
        d.renderContents({ id: 0, sections });
        d.classList.toggle('is-empty', c.item_count === 0);
        setCount(c.item_count);
        d.open(b);
      } catch (x) { root.querySelector('[data-sgl-error]').textContent = x.message; }
    }));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        clearTimeout(window.__sglSync);
        window.__sglSync = setTimeout(() => Gift.sync().then(c => { if (c) setCount(c.item_count); }).catch(x => { const e = D.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-sgl-error]'); if (e) e.textContent = x.message; }), 150);
      });
    }
    const nd = D.querySelector('cart-drawer');
    if (nd) new MutationObserver(() => {
      const q = [...nd.querySelectorAll('.cart-drawer-item .quantity__input')];
      if (q.length) setCount(q.reduce((n, i) => n + Number(i.value || 0), 0));
      else if (nd.classList.contains('is-empty')) setCount(0);
    }).observe(nd, { subtree: true, childList: true });
    D.addEventListener('click', e => {
      const b = e.target.closest('cart-drawer [name="checkout"],cart-drawer a[href$="/checkout"]');
      if (!b || b.dataset.sglReady === '1') return;
      e.preventDefault(); e.stopImmediatePropagation();
      Gift.sync().then(() => { const n = D.querySelector('cart-drawer [name="checkout"]') || b; n.dataset.sglReady = '1'; n.click(); delete n.dataset.sglReady; })
        .catch(x => { const el = D.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-sgl-error]'); if (el) el.textContent = x.message; });
    }, true);
    Gift.sync().then(c => { if (c) setCount(c.item_count); }).catch(() => {});

    /* Policy dialog */
    const dlg = D.querySelector('#sgl-policy');
    if (dlg) {
      D.querySelectorAll('[data-sgl-policy]').forEach(b => b.addEventListener('click', () => dlg.showModal()));
      dlg.querySelector('[data-sgl-close]').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    }

    /* Sample pill appears once the banner scrolls away */
    const ban = D.querySelector('.sg-banner'), pill = D.querySelector('.sg-pill-sample');
    if (pill) {
      if (ban && 'IntersectionObserver' in window) new IntersectionObserver(es => pill.classList.toggle('is-on', !es[0].isIntersecting)).observe(ban);
      else pill.classList.add('is-on');
    }

    /* Sticky bar */
    const sticky = D.querySelector('[data-sgl-sticky]'), buy = root.querySelector('.sg-buy .sg-atc');
    if (sticky && buy) {
      let sraf;
      const check = () => {
        cancelAnimationFrame(sraf);
        sraf = requestAnimationFrame(() => {
          const r = buy.getBoundingClientRect();
          const close = D.querySelector('.sg-close-card .sg-btn--atc');
          const cr = close && close.getBoundingClientRect();
          const show = r.bottom < 0 && !(cr && cr.top < innerHeight && cr.bottom > 0);
          sticky.classList.toggle('is-on', show);
          sticky.setAttribute('aria-hidden', String(!show));
          sticky.querySelector('button').tabIndex = show ? 0 : -1;
        });
      };
      addEventListener('scroll', check, { passive: true });
      addEventListener('resize', check);
      check();
    }
  }

  function widgets() {
    /* Fit checker */
    D.querySelectorAll('[data-sgl-fit]').forEach(f => {
      if (f.dataset.ready) return;
      f.dataset.ready = '1';
      const tabs = [...f.querySelectorAll('[data-fx]')], ans = [...f.querySelectorAll('[data-fx-ans]')];
      tabs.forEach(b => b.addEventListener('click', () => {
        tabs.forEach(x => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', String(on)); });
        ans.forEach(a => { a.hidden = a.dataset.fxAns !== b.dataset.fx; });
      }));
    });
    /* Roll calculator */
    D.querySelectorAll('[data-sgl-calc]').forEach(c => {
      if (c.dataset.ready) return;
      c.dataset.ready = '1';
      const val = { doors: 1, windows: 2 };
      const perDoor = Number(c.dataset.perDoor || 1), perWin = Number(c.dataset.perWindow || 0.85);
      const out = c.querySelector('[data-calc-out]'), sub = c.querySelector('[data-calc-sub]'), btn = c.querySelector('[data-calc-pick]');
      const names = { 1: c.dataset.name1, 2: c.dataset.name2, 3: c.dataset.name3 };
      function upd() {
        c.querySelectorAll('[data-calc-val]').forEach(o => { o.textContent = val[o.dataset.calcVal]; });
        const need = Math.max(1, Math.ceil(val.doors * perDoor + val.windows * perWin - 0.001));
        const p = need <= 1 ? 1 : need <= 3 ? 2 : 3;
        const extra = need > 6 ? need - 6 : 0;
        out.textContent = need + (need === 1 ? ' roll' : ' rolls');
        sub.textContent = extra ? names[3] + ' plus ' + extra + ' extra ' + (extra === 1 ? 'roll' : 'rolls') : names[p] + ' covers it';
        btn.dataset.pack = p;
        btn.querySelector('span').textContent = names[p];
      }
      c.querySelectorAll('[data-calc]').forEach(b => b.addEventListener('click', () => {
        const k = b.dataset.calc, d = Number(b.dataset.d);
        val[k] = Math.max(0, Math.min(20, val[k] + d));
        if (val.doors + val.windows === 0) val[k] = 1;
        upd();
      }));
      btn.addEventListener('click', () => { if (api) api.selectPack(Number(btn.dataset.pack)); });
      upd();
    });
    /* Kit cards */
    D.querySelectorAll('[data-sgl-kit-pick]').forEach(b => {
      if (b.dataset.ready) return;
      b.dataset.ready = '1';
      b.addEventListener('click', () => { if (api) api.toggleAddon(b.dataset.sglKitPick); });
    });
    /* Thermal before and after */
    D.querySelectorAll('[data-sgl-ba]').forEach(ba => {
      if (ba.dataset.ready) return;
      ba.dataset.ready = '1';
      const r = ba.querySelector('[data-sgl-ba-range]');
      const setv = v => ba.style.setProperty('--pos', v + '%');
      r.addEventListener('input', () => setv(r.value));
      setv(r.value);
      if (!reduce() && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(es => {
          if (!es[0].isIntersecting) return;
          io.disconnect();
          let v = 50, dir = 1, n = 0;
          const tm = setInterval(() => {
            v += dir * 1.6;
            if (v >= 82) dir = -1;
            if (v <= 50 && dir < 0) { clearInterval(tm); v = 50; }
            r.value = v; setv(v);
            if (++n > 120) clearInterval(tm);
          }, 16);
        }, { threshold: 0.5 });
        io.observe(ba);
      }
    });
    /* Number the mobile pin markers */
    D.querySelectorAll('.sg-anno').forEach(a => a.querySelectorAll('.sg-pin i').forEach((i, k) => { i.textContent = k + 1; }));
  }

  const boot = () => { init(); widgets(); };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  D.addEventListener('shopify:section:load', () => { updateShipDates(); widgets(); D.querySelectorAll('.sg-s[data-sgl-reveal]').forEach(s => s.classList.add('is-in')); });
})();
